import React, { ReactElement, useState } from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
import { Alert, Col, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import TextField from '../Partials/TextField';
import {
  AccountDeletionFormRequest,
} from '../../../structures/requests/AccountDeletionFormRequest';
import createAccountDeletionRequestForm from '../../../utils/ajax/AccountDeletionRequestFormAjax';
import AccountDeletionRequestValidation from './validation';

interface AccountDeletionRequestProps {
  //
}

const AccountDeletionRequestForm: React.FC<AccountDeletionRequestProps> = (props): ReactElement => {
  const formProps = {
    initialValues: {
      message: '',
    },
    validateOnChange: false,
    validateOnBlur: true,
  };
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [formError, setFormError] = useState<string | null>(null);

  // Hide form after submission
  if (submitted) {
    return (
      <div className="alert alert-success">
        Your request has been sent. Thanks!
      </div>
    );
  }

  // Render form
  return (
    <>
      <Formik
        {...formProps}
        validationSchema={AccountDeletionRequestValidation}
        onSubmit={async (values, helpers) => {
          setLoading(true);
          const formValues: AccountDeletionFormRequest = values;
          createAccountDeletionRequestForm(formValues)
            .then(() => {
              setLoading(false);
              setSubmitted(true);
            })
            .catch((e) => {
              setLoading(false);
              if (e.response?.status === 422) {
                const { errors } = e.response.data;
                Object.keys(errors)
                  .forEach((key) => {
                    if (Object.prototype.hasOwnProperty.call(errors, key)) {
                      helpers.setFieldError(key, errors[key]);
                    }
                  });
              } else {
                // Set the form-wide error
                setFormError('Something went wrong. Please try again.');
              }
            });
        }}
      >
        {(formikProps) => {
          const {
            submitCount,
            errors,
          } = formikProps;

          const errorDisplay: Array<React.ReactElement> = [];

          if (formError) {
            errorDisplay.push(
              <Alert variant="danger" className="w-100">
                {formError}
              </Alert>,
            );
          }

          if (submitCount) {
            Object.keys(errors)
              .forEach((errorKey) => {
                errorDisplay.push(
                  <Alert variant="danger" className="w-100">
                    {errors[errorKey]}
                  </Alert>,
                );
              });
          }

          return (
            <Form>
              <Row>
                <Col xs={12}>
                  <TextField
                    showLabel={false}
                    formikProps={formikProps}
                    fieldName="message"
                    visibleName="Reason for account deletion"
                    showAsTextarea={true}
                  />
                </Col>
              </Row>

              <Row>
                {errorDisplay}
              </Row>

              <Row className="pb-3">
                <div className="col">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary text-uppercase basic-family"
                    disabled={loading}
                  >
                    Send Request
                  </button>
                </div>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AccountDeletionRequestForm;

const elem = document.getElementById('react-account-deletion-request-form');

if (elem) {
  ReactDOM.render(
    <AccountDeletionRequestForm />,
    elem,
  );
}
